import { Box, Typography } from "@mui/material";

const statusStyles: Record<string, string> = {
  ACTIVE: "#60a5fa",
  CASHED_OUT: "#34d399",
  LOST: "#f87171",
  INITIALIZED: "#94a3b8",
  REJECTED: "#f87171",
  SHOULD_CASHOUT: "#fbbf24",
  SHOULD_ROLLBACK: "#fbbf24",
  ROLLED_BACK: "#94a3b8",
  SHOULD_CANCEL: "#fbbf24",
  CANCELLED: "#94a3b8",

  BETTING_OPEN: "#60a5fa",
  BETTING_CLOSING: "#fbbf24",
  FLYING: "#34d399",
  CRASHED: "#f87171",
  COMPLETED: "#94a3b8",

  MATCH: "#34d399",
  STATUS_MISMATCH: "#f87171",
  AMOUNT_MISMATCH: "#fbbf24",
  MISSING_IN_FDB: "#f87171",
  MISSING_IN_DB: "#f87171",

  DRAFT: "#94a3b8",
  PAUSED: "#fbbf24",
  ENDED: "#94a3b8",
  PENDING: "#60a5fa",
  IN_PROGRESS: "#a78bfa",
  EXPIRED: "#94a3b8",
};

const defaultColor = "#94a3b8";

export const StatusChip = ({ value }: { value?: string | null }) => {
  if (!value) return null;
  const color = statusStyles[value] ?? defaultColor;
  return (
    <Box sx={{ display: "inline-flex", alignItems: "center", gap: 0.75 }}>
      <Box
        sx={{
          width: 6,
          height: 6,
          borderRadius: "50%",
          backgroundColor: color,
          flexShrink: 0,
        }}
      />
      <Typography
        component="span"
        sx={{
          fontSize: "0.72rem",
          fontFamily: "'JetBrains Mono', monospace",
          color,
          fontWeight: 500,
          lineHeight: 1,
        }}
      >
        {value}
      </Typography>
    </Box>
  );
};
